import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { ISelectedFile } from './useImageViewerState'

export const useImageViewerActions = (): {
  handleViewFiles: (selectedFiles: ISelectedFile[]) => void
} => {
  const navigate = useNavigate()

  const handleViewFiles = useCallback(
    (selectedFiles: ISelectedFile[]): void => {
      if (selectedFiles.length > 0) {
        // Filter files that have both study_uid and series_uid
        const files = selectedFiles
          .filter((file) => file.study_uid !== null && file.series_uid !== null)
          .map((file) => ({
            study_uid: file.study_uid!,
            series_uid: file.series_uid!,
          }))

        if (files.length > 0) {
          navigate('/image-viewer/viewer', {
            state: { files },
          })
        }
      }
    },
    [navigate],
  )

  return {
    handleViewFiles,
  }
}
